import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function validateRut(value: string): boolean {
  const rut = value.replace(/\./g, '').replace('-', '').toLowerCase();
  if (rut.length < 8) return false;

  const body = rut.slice(0, -1);
  const dv = rut.slice(-1);

  if (!/^\d+$/.test(body)) return false;

  let sum = 0;
  let multiplier = 2;
  for (let i = body.length - 1; i >= 0; i--) {
    sum += parseInt(body[i], 10) * multiplier;
    multiplier = multiplier === 7 ? 2 : multiplier + 1;
  }

  const remainder = 11 - (sum % 11);
  let expected: string;
  if (remainder === 11) {
    expected = '0';
  } else if (remainder === 10) {
    expected = 'k';
  } else {
    expected = String(remainder);
  }

  return dv === expected;
}

export const rutValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const value = control.value as string;
  if (!value) return null;
  return validateRut(value) ? null : { invalidDocument: true };
};
